//file:dashboardAction.js
//import dependencies
//export:setPassengerState,setCommercialState
import{scenarioCataloguedashboardActions} from './../../constants';

export const setPassengerState = (data) => {
    return {
        type: scenarioCataloguedashboardActions().passengerState,
        text: "passenger",
        data: data
    }
}

export const setCommercialState = (data) => {
    return {
        type: scenarioCataloguedashboardActions().commercialState,
        text: "commercial",
        data: data
    }
}
